import React from 'react';
import ReactDOM from 'react-dom/client';
/* File-based themes (base + each *.theme.css) loaded via themes/index */
import './themes';
import './styles/global.css';
import App from './App';
import { bootstrapTheme } from './utils/theme';

bootstrapTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
